import { Injectable, signal, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, interval, Subscription, catchError, of } from 'rxjs';
import { prodAPI } from '../../../env';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementsService implements OnDestroy {
  private apiUrl = `${prodAPI}/api/announcements`;
  private activeAnnouncementsSignal = signal<string[]>([]);
  private pollingSubscription?: Subscription;
  private readonly POLLING_INTERVAL = 30000; // 30 секунд

  constructor(private http: HttpClient) {
    this.startPolling();
  }

  ngOnDestroy(): void {
    this.stopPolling();
  }

  getActiveAnnouncements() {
    return this.activeAnnouncementsSignal.asReadonly();
  }

  fetchAnnouncements(): Observable<string[]> {
    return this.http.get<string[]>(this.apiUrl).pipe(
      catchError(err => {
        console.error('API request failed:', err);
        return of([]);
      })
    );
  }

  loadAnnouncements(): void {
    this.fetchAnnouncements().subscribe({
      next: (announcements) => {
        const realAnnouncements = announcements || [];
        console.log('Announcements from API:', realAnnouncements);
        this.activeAnnouncementsSignal.set(realAnnouncements);
      },
      error: (err) => {
        console.error('Failed to load announcements:', err);
        this.activeAnnouncementsSignal.set([]);
      }
    });
  }

  private startPolling(): void {
    this.loadAnnouncements();
    
    this.pollingSubscription = interval(this.POLLING_INTERVAL).subscribe(() => {
      this.loadAnnouncements();
    });
  }

  private stopPolling(): void {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }

  refreshAnnouncements(): void {
    this.loadAnnouncements();
  }
}
